import { render, staticRenderFns } from "./MessageComponent.vue?vue&type=template&id=1b1236cf&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./MessageComponent.vue?vue&type=script&lang=js&"
export * from "./MessageComponent.vue?vue&type=script&lang=js&"
import style0 from "./MessageComponent.vue?vue&type=style&index=0&id=1b1236cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1236cf",
  null
  
)

component.options.__file = "MessageComponent.vue"
export default component.exports